/* eslint-disable no-nested-ternary */
import Web from './Web';

// eslint-disable-next-line no-nested-ternary
const myInterface =
  typeof window.Android !== 'undefined'
    ? window.Android
    : typeof window.Ios !== 'undefined'
    ? window.Ios
    : Web;

export default myInterface;
